module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h1', {
    staticClass: "section-title"
  }, [(_vm.firstLogin) ? [_vm._v(_vm._s(_vm.$t('pos.account.password.change-password')))] : [_vm._v(_vm._s(_vm.$t('pos.login.reset-your-password')))]], 2), _c('p', {
    staticClass: "section-description"
  }, [(_vm.activationCode) ? [_vm._v(_vm._s(_vm.$t('pos.login.update-password')))] : [_vm._v(_vm._s(_vm.$t('pos.login.recover-password')))]], 2), _c('div', {
    staticClass: "row recovery-block"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3'), (_vm.activationCode) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onChangePassword($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.$t("pos.login.placeholder.password"),
      "type": "password",
      "data-test": "password"
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.$t("pos.account.password.repeat-new-password"),
      "type": "password",
      "data-test": "password-confirm"
    },
    model: {
      value: (_vm.newPasswordConfirm),
      callback: function($$v) {
        _vm.newPasswordConfirm = $$v
      },
      expression: "newPasswordConfirm"
    }
  })], 1), _c('gotu-nav-button', {
    attrs: {
      "type": "submit",
      "theme": "default-cta",
      "disabled": _vm.loading,
      "loading": _vm.loading,
      "data-test": "change-password"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.login.change-password')))])], 1) : _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSendPasswordResetEmail($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.$t("pos.login.placeholder.email"),
      "type": "email",
      "data-test": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _c('gotu-nav-button', {
    attrs: {
      "type": "submit",
      "theme": "default-cta",
      "disabled": _vm.loading,
      "loading": _vm.loading,
      "data-test": "reset-password"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.login.send-password-reset-email')))])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b48670a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/password-recovery/PasswordRecovery.vue
// module id = 2026
// module chunks = 1